import { observable } from "mobx";
import { Type } from "class-transformer";
import Enum from "./enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InventoryAccountsResponse extends Enum {
  id!: string;

  @observable
  syntheticAccount!: string;

  @observable
  analyticAccount!: boolean;

  @observable
  @Type(() => Date)
  validSinceDate!: Date;

  @observable
  @Type(() => Date)
  validUntilDate?: Date;
}
